import assign from 'object-assign';
import { EventEmitter } from 'events';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'ORDERS_ACCOUNTING_CHANGED';
const ledgerTypes = {
    RECEIVABLES: 'receivables',
    PAYABLES: 'payables',
};
const generateLedgerStatus = {
    [ledgerTypes.RECEIVABLES]: null,
    [ledgerTypes.PAYABLES]: null,
};
const OrdersAccountingStore = assign({}, EventEmitter.prototype, {
    emitChange(ledgerType) {
        this.emit(CHANGE_EVENT, ledgerType);
    },
    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    setGenerateInvoiceStatus({ ledger, success, errorMessage }) {
        generateLedgerStatus[ledgerTypes.RECEIVABLES] = {
            success,
            errorMessage,
            ledger,
        };
        this.emitChange(ledgerTypes.RECEIVABLES);
    },
    setGeneratePayoutStatus({ ledger, success, errorMessage }) {
        generateLedgerStatus[ledgerTypes.PAYABLES] = {
            success,
            errorMessage,
            ledger,
        };
        this.emitChange(ledgerTypes.PAYABLES);
    },
    getGenerateLedgerStatus(ledgerType) {
        return generateLedgerStatus[ledgerType];
    },
});
OrdersAccountingStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
    const action = payload.action;
    switch (action.type) {
        case ActionTypes.GENERATE_ORDER_INVOICE_SUCCESS:
            OrdersAccountingStore.setGenerateInvoiceStatus({
                success: true,
                errorMessage: null,
                ledger: action.ledger,
            });
            break;
        case ActionTypes.GENERATE_ORDER_INVOICE_FAIL:
            OrdersAccountingStore.setGenerateInvoiceStatus({
                success: false,
                errorMessage: action.error,
            });
            break;
        case ActionTypes.GENERATE_ORDER_PAYOUT_SUCCESS:
            OrdersAccountingStore.setGeneratePayoutStatus({
                success: true,
                errorMessage: null,
                ledger: action.ledger,
            });
            break;
        case ActionTypes.GENERATE_ORDER_PAYOUT_FAIL:
            OrdersAccountingStore.setGeneratePayoutStatus({
                success: false,
                errorMessage: action.error,
            });
            break;
        default:
            break;
    }
});
export default OrdersAccountingStore;
